export const ProductSelect = () => ({
  isOpen: false,
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  },
  closeDropdown() {
    this.isOpen = false;
  },
  selectProduct(product) {
    this.selectedProduct = product;
    this.closeDropdown();
  },
});
